import { Utils } from 'cc-common';
import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';

export class OpenPropertyConveyanceResultDto {
    allowProcess: boolean;
    allowEditCommunity: boolean;
    allowClearCommunity: boolean;
    allowDelete: boolean;
    workQueueId: number;
    status: string;

    @Type(() => Date)
    startTime: Date;

    @Type(() => UserNameDisplayResultDto)
    addedBy: UserNameDisplayResultDto;

    paperworkUrl: string;
    customerId: string;
    communityId: number;

    community: string;
    propertyAddress: string;
    hasNotes: boolean;
    managementCompany: string;

    get addedByDisplayText(): string {
        return Utils.notNullAndDefined(this.addedBy) ? this.addedBy.displayName : '';
    }
}
